// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8744) return "static/chunks/8744.56d5e2074f03779d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"3715":"b40df164d60f73f1","5026":"b0353db1f5e32d75"}[chunkId] + ".js";
};